var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type == 'number')?_c('el-input-number',{attrs:{"placeholder":_vm.placeholder,"controls":false,"min":_vm.min,"max":_vm.max,"size":_vm.size}}):(_vm.type =='decimal')?_c('el-input-number',{attrs:{"precision":_vm.precision,"placeholder":_vm.placeholder,"controls":false,"min":_vm.min,"max":_vm.max,"size":_vm.size}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a909fd7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mt/MtInputNumber/index.vue
// module id = null
// module chunks = 